import UpdateStockTake from "../../../../components/@documents/stock_takes/UpdateStockTake";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function StockTakeUpdatePage() {

    return (
        <UpdateStockTake 
            routeType={routeTypes.workstation}
        />
    )
}